import { faBedPulse } from "@fortawesome/free-solid-svg-icons";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslate } from "../../context/TranslationContext";
import { useGetCreatorsByCategoryQuery } from "../../redux/Apis/Category";
import Button from "../button";
import InstructorCard from "../cards/InstructorCard";
import OwlCarousel from "../carousel";
import SkeletonCourseCard from "./SkeletonCourseCard";

const InstructorSection = (showCreatorSection) => {
  const { t } = useTranslate("instructorbanner");
  const lang = useSelector((state) => state.language.lang);
  const { data, isLoading, refetch } = useGetCreatorsByCategoryQuery(
    { page: 1, rowsPerPage: 7, lang },
    { refetchOnMountOrArgChange: true }
  );

  useEffect(() => {
    refetch();
  }, []);

  const instructors = data?.data || [];

  if (!showCreatorSection) return null;

  return (
    <section className="meet-instructors py-sm-5 py-4">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 px-0 text-center">
            <h1 className="gallery-title text-uppercase text-white mb-3">
              {t("title")}
            </h1>
            <p className="mb-4 p-lg l-grey-text">{t("subtitle")}</p>

            {isLoading ? (
              <div className="d-flex flex-wrap justify-content-center">
                <SkeletonCourseCard length={7} />
              </div>
            ) : (
              <div className="d-flex flex-wrap justify-content-center">
                <OwlCarousel
                  className="category-carousel"
                  options={{
                    margin: 10,
                    loop: false,
                    nav: true,
                    dots: false,
                    lazyLoad: true,
                    autoplay: true,
                    autoplayTimeout: 5000,
                    autoplayHoverPause: true,
                    smartSpeed: 500,
                    navText: [
                      '<i class="fas fa-angle-left"></i>',
                      '<i class="fas fa-angle-right"></i>',
                    ],
                    responsive: {
                      0: { items: 2, stagePadding: 0, autoplay: false },
                      576: {
                        items: 2,
                        stagePadding: 20,
                        autoplay: faBedPulse,
                      },
                      768: {
                        items: 3,
                        stagePadding: 0,
                        autoplay: true,
                      },
                      992: {
                        items: 4,
                        stagePadding: 0,
                        autoplay: true,
                      },
                      1200: {
                        items: 5,
                        stagePadding: 0,
                        autoplay: true,
                      },
                    },
                  }}
                >
                  {instructors.map((item) => (
                    <div key={item._id} className="item">
                      <InstructorCard data={item} />
                    </div>
                  ))}
                </OwlCarousel>

                <div className="text-center mt-4">
                  <Button text={t("morebtn")} to="/instructors" />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default InstructorSection;
